import { Outlet } from 'react-router';
import Sidebar from './Sidebar';
import React, { Suspense, useState } from 'react';
import { Button } from '@/components/ui/button';
import { PageSkeleton } from '@/components/ui/DataLoader';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { Menu } from 'lucide-react';

interface LayoutProps {
  children?: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="flex h-screen bg-background">
      {/* Desktop Sidebar */}
      <div className="hidden lg:block h-full">
        <Sidebar />
      </div>

      {/* Mobile Menu */}
      <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
        <SheetTrigger asChild>
          <Button
            variant="ghost"
            className="lg:hidden fixed top-4 left-4 z-40"
            size="icon"
          >
            <Menu className="h-6 w-6" />
          </Button>
        </SheetTrigger>
        <SheetContent side="left" className="p-0 w-64">
          <Sidebar onNavigate={() => setMobileMenuOpen(false)} />
        </SheetContent>
      </Sheet>

      {/* Relative, so absolute sr-only labels scroll here instead of growing
          the window into a second scrollbar. */}
      <main className="relative flex-1 overflow-auto pl-8 lg:pl-0">
        <Suspense fallback={<PageSkeleton />}>
          {children || <Outlet />}
        </Suspense>
      </main>
    </div>
  );
}
